var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleplayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 50,
    viewBox: "0 0 173 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.14 49.9999H7.05736C3.57649 49.9999 0.740234 47.1966 0.740234 43.7562V6.26901C0.740234 2.82865 3.57649 0.0253906 7.05736 0.0253906H165.14C168.622 0.0253906 171.457 2.82865 171.457 6.26901V43.7562C171.457 47.1966 168.596 49.9999 165.14 49.9999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.14 0.996813C168.08 0.996813 170.452 3.34136 170.452 6.24655V43.7338C170.452 46.639 168.08 48.9836 165.14 48.9836H7.05736C4.11796 48.9836 1.74583 46.639 1.74583 43.7338V6.24655C1.74583 3.34136 4.11796 0.996813 7.05736 0.996813H165.14ZM165.14 0.00292969H7.05736C3.5765 0.00292969 0.740234 2.80619 0.740234 6.24655V43.7338C0.740234 47.1742 3.5765 49.9774 7.05736 49.9774H165.14C168.621 49.9774 171.457 47.1742 171.457 43.7338V6.24655C171.457 2.80619 168.596 0.00292969 165.14 0.00292969Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.693 12.8186C60.693 13.8635 60.3836 14.7045 59.7648 15.3161C59.0428 16.0551 58.1146 16.4374 56.9802 16.4374C55.8972 16.4374 54.9432 16.0551 54.1954 15.3161C53.4219 14.5516 53.0352 13.6342 53.0352 12.5128C53.0352 11.3916 53.4219 10.4741 54.1954 9.73506C54.9689 8.99604 55.8972 8.61377 56.9802 8.61377C57.5216 8.61377 58.0373 8.7157 58.5272 8.91957C59.017 9.12345 59.4296 9.40381 59.7133 9.76059L59.0428 10.4232C58.5272 9.83702 57.8568 9.53122 56.9544 9.53122C56.155 9.53122 55.4588 9.81148 54.8916 10.3722C54.2985 10.9328 54.015 11.6464 54.015 12.5384C54.015 13.4303 54.2985 14.1438 54.8916 14.7045C55.4846 15.2651 56.1808 15.5455 56.9544 15.5455C57.8052 15.5455 58.5014 15.2651 59.0686 14.7045C59.4296 14.3477 59.6617 13.838 59.7133 13.1754H56.9544V12.2835H60.6157C60.693 12.4364 60.693 12.6148 60.693 12.8186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5238 9.68412H63.0687V12.0541H66.1886V12.9461H63.0687V15.3162H66.5238V16.2336H62.0889V8.74121H66.5238C66.5238 8.76669 66.5238 9.68412 66.5238 9.68412Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6415 16.259H69.6616V9.68405H67.5474V8.7666H72.7558V9.68405H70.6415V16.259Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5215 16.259V8.7666H77.5012V16.259H76.5215Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8334 16.259H80.8536V9.68405H78.7393V8.7666H83.9477V9.68405H81.8334V16.259Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.825 15.2903C93.0777 16.0547 92.1491 16.437 91.0402 16.437C89.9313 16.437 89.0034 16.0547 88.2557 15.2903C87.508 14.5257 87.147 13.6083 87.147 12.5125C87.147 11.4166 87.508 10.4737 88.2557 9.73472C89.0034 8.97017 89.9313 8.58789 91.0402 8.58789C92.1491 8.58789 93.0777 8.97017 93.825 9.73472C94.5732 10.4992 94.9598 11.4166 94.9598 12.5125C94.934 13.6083 94.5732 14.5257 93.825 15.2903ZM88.9777 14.6531C89.5447 15.2137 90.2152 15.4941 91.0402 15.4941C91.8393 15.4941 92.5357 15.2137 93.1027 14.6531C93.6706 14.0925 93.9536 13.3789 93.9536 12.487C93.9536 11.595 93.6706 10.8815 93.1027 10.3208C92.5357 9.76017 91.8652 9.47981 91.0402 9.47981C90.2152 9.47981 89.5447 9.76017 88.9777 10.3208C88.4104 10.8815 88.1268 11.595 88.1268 12.487C88.1268 13.3789 88.4104 14.0925 88.9777 14.6531Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2964 16.259V8.7666H97.483L101.17 14.6025H101.221L101.17 13.1499V8.7666H102.15V16.259H101.144L97.2767 10.1428H97.225L97.2767 11.5954V16.259H96.2964Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8926 27.1918C83.9275 27.1918 81.5037 29.4344 81.5037 32.518C81.5037 35.5761 83.9275 37.8442 86.8926 37.8442C89.858 37.8442 92.3071 35.5761 92.3071 32.518C92.3071 29.4344 89.8839 27.1918 86.8926 27.1918ZM86.8926 35.729C85.2683 35.729 83.8501 34.4038 83.8501 32.518C83.8501 30.6067 85.2425 29.307 86.8926 29.307C88.5428 29.307 89.9348 30.6067 89.9348 32.518C89.9348 34.4038 88.517 35.729 86.8926 35.729ZM75.135 27.1918C72.1699 27.1918 69.7461 29.4344 69.7461 32.518C69.7461 35.5761 72.1699 37.8442 75.135 37.8442C78.1002 37.8442 80.524 35.5761 80.524 32.518C80.524 29.4344 78.1002 27.1918 75.135 27.1918ZM75.135 35.729C73.5107 35.729 72.0925 34.4038 72.0925 32.518C72.0925 30.6067 73.5107 29.307 75.135 29.307C76.7594 29.307 78.1775 30.6067 78.1775 32.518C78.1518 34.4038 76.7594 35.729 75.135 35.729ZM61.1084 28.8228V31.0909H66.5747C66.42 32.3652 65.9816 33.2826 65.337 33.9196C64.5377 34.7096 63.3001 35.5761 61.1084 35.5761C57.7565 35.5761 55.1265 32.9002 55.1265 29.5873C55.1265 26.2744 57.7565 23.5985 61.1084 23.5985C62.9133 23.5985 64.2541 24.3121 65.2339 25.2041L66.8325 23.624C65.4659 22.3243 63.6611 21.356 61.1084 21.356C56.4931 21.356 52.6255 25.0511 52.6255 29.6128C52.6255 34.1745 56.4931 37.8697 61.1084 37.8697C63.6095 37.8697 65.4659 37.0542 66.9357 35.5506C68.4311 34.0726 68.921 31.9574 68.921 30.2754C68.921 29.7402 68.8695 29.256 68.7921 28.8738C68.7921 28.8228 61.1084 28.8228 61.1084 28.8228ZM118.401 30.5812C117.962 29.3835 116.596 27.1918 113.786 27.1918C111.027 27.1918 108.706 29.358 108.706 32.518C108.706 35.4997 110.975 37.8442 114.044 37.8442C116.519 37.8442 117.937 36.3661 118.529 35.4997L116.699 34.3019C116.08 35.1938 115.255 35.78 114.044 35.78C112.857 35.78 111.98 35.2448 111.439 34.1745L118.633 31.2438C118.659 31.1674 118.401 30.5812 118.401 30.5812ZM111.079 32.3396C111.027 30.3009 112.677 29.2306 113.888 29.2306C114.817 29.2306 115.616 29.6893 115.9 30.3519C115.874 30.3774 111.079 32.3396 111.079 32.3396ZM105.225 37.5129H107.597V21.8911H105.225V37.5129ZM101.358 28.3641H101.28C100.738 27.7525 99.733 27.1918 98.4437 27.1918C95.7625 27.1918 93.2875 29.5364 93.2875 32.518C93.2875 35.4997 95.7625 37.8187 98.4437 37.8187C99.733 37.8187 100.738 37.2581 101.28 36.621H101.358V37.3855C101.358 39.4243 100.249 40.5201 98.4955 40.5201C97.0517 40.5201 96.1491 39.5007 95.7883 38.6343L93.7258 39.4752C94.3187 40.8769 95.891 42.6098 98.4955 42.6098C101.28 42.6098 103.601 41.0043 103.601 37.0797V27.5231H101.358V28.3641ZM98.65 35.729C97.0258 35.729 95.6589 34.3784 95.6589 32.518C95.6589 30.6322 97.0258 29.2815 98.65 29.2815C100.249 29.2815 101.512 30.6577 101.512 32.518C101.512 34.3784 100.249 35.729 98.65 35.729ZM129.488 21.8656H123.841V37.4875H126.187V31.5751H129.488C132.118 31.5751 134.67 29.6893 134.67 26.7331C134.67 23.7515 132.092 21.8656 129.488 21.8656ZM129.54 29.4089H126.187V24.0573H129.54C131.293 24.0573 132.298 25.5099 132.298 26.7331C132.298 27.9309 131.293 29.4089 129.54 29.4089ZM144.134 27.1663C142.432 27.1663 140.653 27.9053 139.93 29.5619L142.02 30.4283C142.458 29.5618 143.309 29.2815 144.185 29.2815C145.397 29.2815 146.661 30.0206 146.661 31.2948V31.4477C146.222 31.1928 145.32 30.836 144.185 30.836C141.942 30.836 139.621 32.0593 139.621 34.3529C139.621 36.4426 141.478 37.7933 143.54 37.7933C145.139 37.7933 146.016 37.0797 146.557 36.2642H146.635V37.4619H148.904V31.4732C148.929 28.7209 146.841 27.1663 144.134 27.1663ZM143.85 35.729C143.077 35.729 141.994 35.3468 141.994 34.4038C141.994 33.206 143.334 32.7219 144.495 32.7219C145.526 32.7219 146.016 32.9512 146.661 33.257C146.454 34.7096 145.217 35.729 143.85 35.729ZM157.232 27.4977L154.525 34.2764H154.447L151.637 27.4977H149.084L153.287 36.9523L150.889 42.2275H153.364L159.862 27.4977H157.232ZM135.96 37.5129H138.332V21.8911H135.96V37.5129Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9212 9.42911C13.5602 9.81134 13.3281 10.423 13.3281 11.1875V38.8379C13.3281 39.6023 13.5345 40.214 13.9212 40.5963L14.0244 40.6727L29.7012 25.1783V24.8215L14.0244 9.32715L13.9212 9.42911Z",
    fill: "url(#paint0_linear_2490_5186)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.914 30.3513L29.7056 25.178V24.8213L34.9398 19.6479L35.0687 19.7244L41.2569 23.2157C43.0102 24.2096 43.0102 25.8406 41.2569 26.8345L35.0687 30.3004C35.0429 30.2748 34.914 30.3513 34.914 30.3513Z",
    fill: "url(#paint1_linear_2490_5186)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0359 30.2753L29.6985 25L13.9443 40.5709C14.5374 41.1825 15.4914 41.2589 16.5743 40.6473L35.0359 30.2753Z",
    fill: "url(#paint2_linear_2490_5186)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0313 19.7245L16.5441 9.35244C15.4611 8.74084 14.5071 8.81729 13.9141 9.42887L29.6682 24.9998L35.0313 19.7245Z",
    fill: "url(#paint3_linear_2490_5186)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2490_5186",
    x1: 28.2954,
    y1: 39.1147,
    x2: 2.32484,
    y2: 12.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2490_5186",
    x1: 43.5212,
    y1: 25.0013,
    x2: 5.17795,
    y2: 25.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2490_5186",
    x1: 21.5694,
    y1: 32.5618,
    x2: -13.6488,
    y2: -3.49187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2490_5186",
    x1: -0.601758,
    y1: 39.3523,
    x2: 15.1248,
    y2: 23.2529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayBtn);
export default __webpack_public_path__ + "static/media/googleplay-btn.096d66dceae13313a884cd344b7cc5aa.svg";
export { ForwardRef as ReactComponent };